export function isTouchDevice() {
  return (("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || ((navigator as any).msMaxTouchPoints > 0));
}
